import { getToken, clearToken } from '../utils/authToken';
import React, { createContext, useContext, useState, useCallback, useRef, useEffect } from "react";
import axios from "axios";
import NotificationsOverlay from "../components/NotificationsOverlay";

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const NotificationsContext = createContext(null);

export function NotificationsProvider({ children }) {
  const [notifications, setNotifications] = useState([]);
  const previousBonusRef = useRef(0);
  const previousReferralsRef = useRef(0);
  const isInitializedRef = useRef(false);

  const notify = useCallback((message, type = "info") => {
    const id = Date.now() + Math.random();
    setNotifications((prev) => [...prev, { id, message, type }]);

    setTimeout(() => {
      setNotifications((prev) => prev.filter((n) => n.id !== id));
    }, 4000);
  }, []);

  const clearNotification = useCallback((id) => {
    setNotifications((prev) => prev.filter((n) => n.id !== id));
  }, []);

  // Polling ligero para detectar cambios en bonus y referidos
  useEffect(() => {
    const checkReferralUpdates = async () => {
      const token = getToken();
      if (!token || token === 'guest') return;

      try {
        const response = await axios.get(`${API_URL}/api/referral/info`, {
        });

        const data = response.data;
        const currentBonus = data.bonus_messages_available || 0;
        const currentReferrals = data.referral_count || 0;

        // Solo notificar después de la inicialización
        if (isInitializedRef.current) {
          // Detectar nuevos bonus
          if (currentBonus > previousBonusRef.current) {
            const bonusGained = currentBonus - previousBonusRef.current;
            notify(`¡Ganaste +${bonusGained} mensajes bonus! 🎁`, "bonus");
          }

          // Detectar nuevos referidos
          if (currentReferrals > previousReferralsRef.current) {
            notify("¡Nuevo referido registrado! 🎉", "referral");
          }
        }

        previousBonusRef.current = currentBonus;
        previousReferralsRef.current = currentReferrals;
        isInitializedRef.current = true;

      } catch (error) {
        // Silenciar errores de polling
        console.debug('Polling check skipped:', error.message);
      }
    };

    // Check inicial
    checkReferralUpdates();

    // Polling cada 30 segundos (ligero)
    const interval = setInterval(checkReferralUpdates, 30000);
    
    return () => clearInterval(interval);
  }, [notify]);

  return (
    <NotificationsContext.Provider value={{ notify, notifications, clearNotification }}>
      {children}
      <NotificationsOverlay 
        notifications={notifications} 
        onDismiss={clearNotification} 
      />
    </NotificationsContext.Provider>
  );
}

export function useAppNotifications() {
  const context = useContext(NotificationsContext);
  if (!context) {
    // Fallback silencioso si se usa fuera del provider
    return { 
      notify: () => {}, 
      notifications: [],
      clearNotification: () => {}
    };
  }
  return context;
}

export default NotificationsContext;
